// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_forecast_point_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { WeatherForecastPointSelectionState } from "../../bfftypes/v1/weather_forecast_point_selection_state_pb";
import { file_bfftypes_v1_weather_forecast_point_selection_state } from "../../bfftypes/v1/weather_forecast_point_selection_state_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_forecast_point_model.proto.
 */
export const file_bffuser_v1_weather_forecast_point_model: GenFile = /*@__PURE__*/
  fileDesc("Ci1iZmZ1c2VyL3YxL3dlYXRoZXJfZm9yZWNhc3RfcG9pbnRfbW9kZWwucHJvdG8SCmJmZnVzZXIudjEi6QEKGEFyZWFXZWF0aGVyRm9yZWNhc3RQb2ludBIoCglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRIVCg1sb2NhdGlvbl9uYW1lGAIgASgJEjMKCnVwZGF0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESSAoPc2VsZWN0aW9uX3N0YXRlGAQgASgOMi8uYmZmdHlwZXMudjEuV2VhdGhlckZvcmVjYXN0UG9pbnRTZWxlY3Rpb25TdGF0ZUINCgtfdXBkYXRlZF9hdCKNAQoiQXJlYVdlYXRoZXJGb3JlY2FzdFBvaW50Q2FuZGlkYXRlcxIoCglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRI9CgpjYW5kaWRhdGVzGAIgAygLMikuYmZmdXNlci52MS5XZWF0aGVyRm9yZWNhc3RQb2ludENhbmRpZGF0ZSJMCh1XZWF0aGVyRm9yZWNhc3RQb2ludENhbmRpZGF0ZRIVCg1sb2NhdGlvbl9uYW1lGAEgASgJEhQKDGlzX2F2YWlsYWJsZRgCIAEoCEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bfftypes_v1_weather_forecast_point_selection_state, file_google_protobuf_timestamp]);

/**
 * AreaWeatherForecastPoint holds the *effective* weather-forecast point of a
 * single area — the point the demand forecast actually uses, already resolved
 * by the backend. The frontend renders location_name as-is and never re-derives
 * it from the candidate list.
 * Shape mirrors internalapi.v1.AreaWeatherForecastPoint.
 *
 * @generated from message bffuser.v1.AreaWeatherForecastPoint
 */
export type AreaWeatherForecastPoint = Message<"bffuser.v1.AreaWeatherForecastPoint"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Effective weather-forecast point name (e.g. "札幌"): the saved selection
   * when it is still a candidate, otherwise the area's default (first
   * candidate). Guaranteed to appear in the area's candidate list unless the
   * area has no candidate at all (then empty).
   *
   * @generated from field: string location_name = 2;
   */
  locationName: string;

  /**
   * Optimistic-lock token reflecting the last persistence time. Absent when
   * the area has no saved record (= 未設定). Present even when the saved point
   * was revoked, so a later update still locks against the stored row.
   *
   * @generated from field: optional google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * Why location_name is what it is (明示選択 / 未設定で既定 / 失効で既定).
   *
   * @generated from field: bfftypes.v1.WeatherForecastPointSelectionState selection_state = 4;
   */
  selectionState: WeatherForecastPointSelectionState;
};

/**
 * Describes the message bffuser.v1.AreaWeatherForecastPoint.
 * Use `create(AreaWeatherForecastPointSchema)` to create a new message.
 */
export const AreaWeatherForecastPointSchema: GenMessage<AreaWeatherForecastPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_model, 0);

/**
 * AreaWeatherForecastPointCandidates lists the ordered candidate
 * weather-forecast points for a single area. The first entry is the
 * recommended default. The list is system-fixed master data.
 *
 * @generated from message bffuser.v1.AreaWeatherForecastPointCandidates
 */
export type AreaWeatherForecastPointCandidates = Message<"bffuser.v1.AreaWeatherForecastPointCandidates"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Ordered candidates. The first entry is the default point for the area.
   *
   * @generated from field: repeated bffuser.v1.WeatherForecastPointCandidate candidates = 2;
   */
  candidates: WeatherForecastPointCandidate[];
};

/**
 * Describes the message bffuser.v1.AreaWeatherForecastPointCandidates.
 * Use `create(AreaWeatherForecastPointCandidatesSchema)` to create a new message.
 */
export const AreaWeatherForecastPointCandidatesSchema: GenMessage<AreaWeatherForecastPointCandidates> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_model, 1);

/**
 * WeatherForecastPointCandidate is one selectable point plus its BigQuery
 * availability. is_available=false means the point has no JMA mapping and is
 * shown as 今後実装予定 (disabled) in the admin pulldown.
 *
 * @generated from message bffuser.v1.WeatherForecastPointCandidate
 */
export type WeatherForecastPointCandidate = Message<"bffuser.v1.WeatherForecastPointCandidate"> & {
  /**
   * @generated from field: string location_name = 1;
   */
  locationName: string;

  /**
   * False when the point has no JMA station/area code (BigQuery-unmapped).
   *
   * @generated from field: bool is_available = 2;
   */
  isAvailable: boolean;
};

/**
 * Describes the message bffuser.v1.WeatherForecastPointCandidate.
 * Use `create(WeatherForecastPointCandidateSchema)` to create a new message.
 */
export const WeatherForecastPointCandidateSchema: GenMessage<WeatherForecastPointCandidate> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_model, 2);

